module.exports = __webpack_public_path__ + "img/s04-min.2c6a918f.png";